import { call, put, takeEvery } from "redux-saga/effects";
import { get, merge, noop } from "lodash-es";
import {
  fetch_nominations,
  create_nominee_request,
  update_nominee_request,
  update_nominee_status,
} from "../../apis/nominee";
import {
  createNomineeRequest,
  getNominations,
  setNominations,
  updateEquityNomineeData,
  updateNomineeDetails,
  updateNomineeRequest,
  updateNomineeStatus,
  setDocUploadConfig
} from "../reducers/nominee";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import { getNomineesList } from "../../utils/nominee/functions";

export default function* handleNomineeSagas() {
  yield takeEvery(getNominations.toString(), handleFetchNominations);
  yield takeEvery(createNomineeRequest.toString(), handleCreateNomineeRequest);
  yield takeEvery(updateNomineeRequest.toString(), handleUpdateNomineeRequest);
  yield takeEvery(updateNomineeStatus.toString(), handleUpdateNomineeStatus);
}

function* handleFetchNominations({ payload }) {
  const { Api, token = "", screen } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const nominations = yield call(fetch_nominations, Api, token);
    const mfNominationData = get(nominations, "mutual_fund_nomination", {});
    const equityNominationData = get(nominations, "equity_nomination", {});
    const nominationData = { mfNominationData, equityNominationData };
    yield put(setNominations(nominationData));
    const uploadDocConfig = get(nominations, "equity_nomination.data_required_config.doc", false);
    yield put(setDocUploadConfig(uploadDocConfig));
  } catch (err) {
    console.log(err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleCreateNomineeRequest({ payload }) {
  const {
    Api,
    token = "",
    screen,
    data,
    file,
    requestId,
    sagaCallback,
    equityNominationData,
  } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const result = yield call(
      create_nominee_request,
      Api,
      data,
      file,
      requestId,
      token
    );
    if (!requestId) {
      const nominationData = get(result, "equity_nomination_request", {});
      yield put(updateEquityNomineeData(nominationData));
      const id = get(
        nominationData,
        "eq_nominee_list[0].equity_nominee_id",
        ""
      );
      yield put(updateNomineeDetails({ id }));
    } else {
      const equityNomineeData = get(result, "equity_nominee", {});
      const nomineeList = getNomineesList(equityNominationData);
      const nominationData = merge({}, equityNominationData, {
        eq_nominee_list: [...nomineeList, equityNomineeData],
      });
      yield put(updateEquityNomineeData(nominationData));
      yield put(
        updateNomineeDetails({ id: equityNomineeData.equity_nominee_id })
      );
    }
    yield call(sagaCallback, result);
  } catch (err) {
    console.log(err);
    yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleUpdateNomineeRequest({ payload }) {
  const {
    Api,
    token = "",
    screen,
    data,
    file,
    requestId,
    nomineeId,
    sagaCallback = noop,
    equityNominationData,
  } = payload;
  try {
    yield put(setLoader({ screen, isButtonLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const result = yield call(
      update_nominee_request,
      Api,
      data,
      file,
      requestId,
      nomineeId,
      token
    );

    let nomineesData = [];
    const equityNomineeData = get(result, "equity_nominee", {});
    const nomineeList = getNomineesList(equityNominationData);
    if (equityNomineeData.is_discarded) {
      nomineesData = nomineeList.filter(
        (el) => el.equity_nominee_id !== nomineeId
      );
    } else {
      nomineesData = nomineeList.map((el) => {
        if (el.equity_nominee_id === nomineeId) {
          return merge({}, el, equityNomineeData);
        }
        return el;
      });
    }
    const nominationData = {
      ...equityNominationData,
      eq_nominee_list: nomineesData,
    };
    yield put(updateEquityNomineeData(nominationData));
    yield call(sagaCallback, result);
  } catch (err) {
    console.log(err);
    yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isButtonLoading: false }));
  }
}

function* handleUpdateNomineeStatus({ payload }) {
  const { Api, token = "", screen, data, requestId, esignDetail, sagaCallback } = payload;
  yield put(setLoader({ screen, isButtonLoading: true }));
  try {
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const result = yield call(
      update_nominee_status,
      Api,
      data,
      requestId,
      esignDetail,
      token
    );
    yield put(setLoader({ screen, isButtonLoading: false }));
    const equityNominationData = get(
      result,
      "update_equity_nomination_request",
      {}
    );
    yield put(updateEquityNomineeData(equityNominationData));
    yield call(sagaCallback, result);
  } catch (err) {
    console.log(err);
    yield put(setLoader({ screen, isButtonLoading: false }));
    yield put(setError({ screen, isUpdateFailed: true, message: err.message }));
  }
}
